import { useEffect, useMemo, useState } from 'react';
import { constants } from '../lib/constants';

/**
 * Escalera de valor publica (`public/integrations/get-playbooks`).
 *
 * Devuelve los playbooks PUBLICADOS con sus etapas y su resumen economico, tal
 * y como los calcula el core: el sumatorio NO se recalcula aqui, para que la web
 * y la Tienda de la app no puedan decir cosas distintas.
 */
const usePlaybooks = () => {
   const [playbooks, setPlaybooks] = useState([]);
   const [isLoading, setIsLoading] = useState(true);
   const [hasError, setHasError] = useState(false);

   useEffect(() => {
      let isMounted = true;
      setIsLoading(true);
      setHasError(false);
      fetch(constants.getPlaybooks)
         .then((res) => res.json())
         .then((data) => {
            if (!isMounted) return;
            setPlaybooks(Array.isArray(data) ? data : []);
            setIsLoading(false);
         })
         .catch((e) => {
            if (!isMounted) return;
            console.log(e);
            setHasError(true);
            setIsLoading(false);
         });
      return () => {
         isMounted = false;
      };
   }, []);

   // El orden ES la escalera (`step`); el backend ya lo manda ordenado, pero se
   // reafirma aqui por si alguna vez llega desordenado.
   const ladder = useMemo(
      () => [...playbooks].sort((a, b) => (a.step || 0) - (b.step || 0)),
      [playbooks]
   );

   return { playbooks: ladder, isLoading, hasError };
};

export default usePlaybooks;
